import React from 'react';
import { useTheme } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

interface ErrorMessageProps {
  message: string;
}

export function ErrorMessage({ message }: ErrorMessageProps) {
  const theme = useTheme();

  return (
    <div
      style={{
        padding: '10px',
        background: alpha(theme.palette.error.main, 0.1),
        border: `1px solid ${theme.palette.error.main}`,
        borderRadius: '4px',
        marginBottom: '15px',
        color: theme.palette.storageUi.errorText,
        fontSize: '11px',
      }}
    >
      {message}
    </div>
  );
}
